import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/ico_newwin-white.svg'
import _imports_1 from '../../../public/images/logo-bw.svg'


const _hoisted_1 = {
  id: "footerwrapper",
  class: "page"
}
const _hoisted_2 = { id: "adress" }
const _hoisted_3 = { class: "link-margin" }
const _hoisted_4 = { id: "lankar" }
const _hoisted_5 = { class: "link-margin" }
const _hoisted_6 = ["href", "aria-label"]
const _hoisted_7 = { class: "link-margin" }
const _hoisted_8 = ["href", "aria-label"]
const _hoisted_9 = { class: "link-margin" }
const _hoisted_10 = ["href", "aria-label"]

import { useI18n } from "vue-i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainFooter',
  setup(__props) {

const i18n = useI18n();
const locale = i18n.locale.value;
const fullTelHref =
  "tel:" + i18n.messages.value[locale].footerTelefonnummerHref;
const fullKontaktaOss = i18n.messages.value[locale]["kontakta_oss"].toString();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("address", null, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("a", {
              href: fullTelHref,
              rel: "nofollow",
              tabindex: "0",
              "aria-label": "0771 - 6 7 0 6 7 0"
            }, _toDisplayString(_ctx.$t("footerTelefonnummer")), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[0] || (_cache[0] = _createTextVNode("Bolagsverket", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("footerPostnrOrt")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("a", {
            href: _ctx.$t('kontakta_oss'),
            rel: "noopener",
            "aria-label": _ctx.$t('footerKontaktaOss') + ', våra kontaktvägar på Bolagsverket, öppnas i nytt fönster'
          }, _toDisplayString(_ctx.$t("footerKontaktaOss")), 9, _hoisted_6),
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            alt: "",
            class: "new-window",
            src: _imports_0
          }, null, -1))
        ]),
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("a", {
            href: _ctx.$t('tillganglighet'),
            rel: "noopener",
            "aria-label": _ctx.$t('footerTillganglighet') + ', vår tillgänglighetsredogörelse på Bolagsverket, öppnas i nytt fönster'
          }, _toDisplayString(_ctx.$t("footerTillganglighet")), 9, _hoisted_8),
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            alt: "",
            class: "new-window",
            src: _imports_0
          }, null, -1))
        ]),
        _createElementVNode("span", _hoisted_9, [
          _createElementVNode("a", {
            href: _ctx.$t('personuppgifter'),
            rel: "noopener",
            "aria-label": _ctx.$t('footerPersonuppgifter') + ', hur vi hanterar personuppgifter på Bolagsverket, öppnas i nytt fönster'
          }, _toDisplayString(_ctx.$t("footerPersonuppgifter")), 9, _hoisted_10),
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            alt: "",
            class: "new-window",
            src: _imports_0
          }, null, -1))
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { id: "logga" }, [
        _createElementVNode("img", {
          class: "logo",
          src: _imports_1,
          alt: ""
        })
      ], -1))
    ])
  ]))
}
}

})